// File: 'src/pages/Exam/ExamFooter.jsx'
import React, {useEffect, useState} from "react";
import QuestionControl from "./QuestionControl";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

const ExamFooter = ({appendTo, fullWidth, setFullWidth,}) => {
    const [fullscreen, setFullscreen] = useState(false);
    const [showShortcuts, setShowShortcuts] = useState(false);

    useEffect(() => {
        // Fullscreenchange eventini dinleyen bir fonksiyon
        const handleFullscreenChange = () => {
            // Fullscreen state'ini document.fullscreenElement'e göre ayarla
            setFullscreen(document.fullscreenElement !== null)
        }
        document.addEventListener("fullscreenchange", handleFullscreenChange)
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange)
        }
    }, []);

    const handleFullscreen = () => {
        if (fullscreen) {
            // Full screen modundan çık
            document.exitFullscreen();
            setFullscreen(false);
        } else {
            // Full screen moduna gir
            appendTo.current.requestFullscreen();
            setFullscreen(true);
        }
    }

    const handleFullWidth = () => {
        setFullWidth();
    }

    return (
        <>
            {/*<div className="flex justify-content-between align-items-center">*/}
            {/*<div className="flex justify-content-center">*/}
            {/*    <ExamPhaseControls/>*/}
            {/*</div>*/}


                <div className="flex justify-content-end gap-2">
                    <Button outlined text label="Kısayollar" icon="pi pi-ellipsis-v"
                            onClick={() => setShowShortcuts(true)}/>
                    {setFullWidth && <Button icon="pi pi-arrows-h" size="lg" rounded text onClick={handleFullWidth}/>}
                    <Button icon={fullscreen ? "pi pi-window-minimize" : "pi pi-window-maximize"} rounded text
                            size="lg" onClick={handleFullscreen}/>
                </div>

            <Dialog header="Kısayollar" visible={showShortcuts} style={{width: '35vw'}}
                    onHide={() => setShowShortcuts(false)}>
                <div className="flex flex-column gap-3">
                    <div>
                        <h6 className="font-bold">Soru Kontrolleri</h6>
                        <ul className="list-none p-0 m-0">
                            <li><strong>Mouse Sağ Tıklama (Seçenek Üzerinde):</strong> Seçenek Eleme\Kaldırma</li>
                            <li><strong>Mouse Sol Seçim (Yazı Üzerinde):</strong> Seçili Yazıyı Boyama</li>
                            <li><strong>Mouse Sağ Tıklama (Boyalı Yazı Üzerinde):</strong> Boyanmış Yazıyı Temizleme
                            </li>
                            <li><strong>Mouse Sol Tıklama (Şık Üzerinde):</strong> Şık Seçme</li>
                            <li><strong>Mouse Sol Tıklama (Seçili Şık Üzerinde):</strong> Şıktan Seçimi Kaldırma</li>
                        </ul>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default ExamFooter;